import { doc, getFirestore, runTransaction, serverTimestamp } from "firebase/firestore";
import firebaseApp from "../../firebase/credenciales";
import { CONT_COLLECTIONS } from "./collections";

const db = getFirestore(firebaseApp);

const txt = (v) => (v == null ? "" : String(v).trim());

const formatCorrelativo = (prefijo, secuencia) => {
  const num = Number(secuencia || 0);
  return `${prefijo}-${String(num).padStart(7, "0")}`;
};

export const obtenerSiguienteCorrelativo = async ({ rucEmpresa, prefijo }) => {
  const ruc = txt(rucEmpresa) || "GLOBAL";
  const pre = txt(prefijo).toUpperCase();
  if (!pre) throw new Error("Prefijo inválido para correlativo.");

  const counterRef = doc(db, CONT_COLLECTIONS.CORRELATIVOS, `${ruc}_${pre}`);

  const resultado = await runTransaction(db, async (trx) => {
    const snap = await trx.get(counterRef);
    const actual = snap.exists() ? Number(snap.data()?.secuencia || 0) : 0;
    const siguiente = actual + 1;
    trx.set(
      counterRef,
      {
        ruc_empresa: ruc,
        prefijo: pre,
        secuencia: siguiente,
        updated_at: serverTimestamp(),
        created_at: snap.exists() ? snap.data()?.created_at || serverTimestamp() : serverTimestamp(),
      },
      { merge: true }
    );

    return {
      secuencia: siguiente,
      correlativo: formatCorrelativo(pre, siguiente),
    };
  });

  return resultado;
};

export { formatCorrelativo };
